import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ClanInfo, ClanMinInfo, ClanStat} from "@/store/clan/types";
import {Keys} from "@/constants/key";
import Text = Phaser.GameObjects.Text;
import {ClanBonusPanel} from "@/scenes.ui.clan/clan-bonus-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ClanHeaderPanel extends Phaser.GameObjects.Container {

    private goldLabel!: Text;
    private gemsLabel!: Text;
    private redCrystLabel!: Text;
    private blueLabel!: Text;

    private membLabel!: Text;

    private clanBonusPanel!: ClanBonusPanel;

    constructor(scene: Phaser.Scene, ci: ClanInfo) {
        super(scene);

        this.scene = scene;

        this.init(scene, ci);
        this.setupDefaultDepth();
    }

    public setupDefaultDepth() {
        this.setDepth(100);
    }

    public init(scene: Phaser.Scene, ci: ClanInfo) {
        let clan = ci.clan;

        let infoBack = SpriteUtils.addSprite(scene, 300, -9, Keys.CL_HEADER, undefined, 1.2, 1.28).setOrigin(0.5, 0);

        let nameLabel = TextUtils.addTextAdvanced(scene, clan.name, 300, 20,
            '#ffde09', 24, 'normal', 500, 'center', 2, Fonts.BENGALY_NORMAL);

        this.clanBonusPanel = new ClanBonusPanel(scene, 300, nameLabel.y / CU.S + 25, ci.clanExpRatio, ci.clanDefenceChance, ci.raidDistance, ci.clan.gears, false);

        this.membLabel = TextUtils.addTextAdvanced(scene, Tr('uchastnikov').toUpperCase() + ci.membersCurr + '/' + ci.membersMax + ',  ' + Tr('uroven').toUpperCase() + ': ' + clan.level, 300, this.clanBonusPanel.y / CU.S + 26,
            '#c2c2c2', 11, 'normal', 500, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let expLabel = TextUtils.addTextAdvanced(scene, Tr('opit').toUpperCase() + TextUtils.formatMoney(clan.clanStat.experience) + Tr('sled.ur.bracket') + TextUtils.formatMoney(ci.nextLevelExperience) + Tr('brac.boev') + clan.clanStat.battlesTotal, 300, this.membLabel.y / CU.S + 18,
            '#C2C2C2FF', 11, 'normal', 500, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let resSize = 30 * CU.S;

        let balanceY = expLabel.y / CU.S + 22;

        let goldSign = SpriteUtils.addSprite(scene, 190, balanceY, Keys.IMG_RES_GOLD).setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(goldSign, resSize, resSize);
        this.goldLabel = TextUtils.addTextAdvanced(scene, TextUtils.formatMoney(clan.clanStat.gold), goldSign.x / CU.S + 12, goldSign.y / CU.S,
            '#ffffff', 12, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let gemsSign = SpriteUtils.addSprite(scene, 255, balanceY, Keys.IMG_RES_MITHRIL).setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(gemsSign, resSize, resSize);
        this.gemsLabel = TextUtils.addTextAdvanced(scene, TextUtils.formatMoney(clan.clanStat.gems), gemsSign.x / CU.S + 12, gemsSign.y / CU.S,
            '#FFFFFFFF', 12, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let redCrystSign = SpriteUtils.addSprite(scene, 325, balanceY, Keys.IMG_RES_CRYSTAL).setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(redCrystSign, resSize, resSize);
        this.redCrystLabel = TextUtils.addTextAdvanced(scene, TextUtils.formatMoney(clan.clanStat.redCrystal), redCrystSign.x / CU.S + 12, redCrystSign.y / CU.S,
            '#FFFFFFFF', 12, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let blueCrystSign = SpriteUtils.addSprite(scene, 390, balanceY, Keys.IMG_RES_ELIXIR).setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(blueCrystSign, resSize, resSize);
        this.blueLabel = TextUtils.addTextAdvanced(scene, TextUtils.formatMoney(clan.clanStat.blueCrystal), blueCrystSign.x / CU.S + 12, blueCrystSign.y / CU.S,
            '#FFFFFFFF', 12, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        this.add([infoBack, nameLabel, this.membLabel, expLabel, goldSign, gemsSign, redCrystSign, blueCrystSign,
            this.goldLabel, this.gemsLabel, this.redCrystLabel, this.blueLabel, this.clanBonusPanel]);
    }

    public setMembCount(ci: ClanMinInfo) {
        if (this.membLabel && this.membLabel.active) {
            this.membLabel.setText(Tr('uchastnikov').toUpperCase() + ci.membersCurr + '/' + ci.membersMax + ',  ' + Tr('uroven').toUpperCase() + ': ' + ci.level);
        }
    }

    public setBudget(clanStat: ClanStat): void {
        if (this.active && this.scene.scene.isActive()) {
            this.goldLabel.setText(TextUtils.formatMoney(clanStat.gold));
            this.gemsLabel.setText(TextUtils.formatMoney(clanStat.gems));
            this.redCrystLabel.setText(TextUtils.formatMoney(clanStat.redCrystal));
            this.blueLabel.setText(TextUtils.formatMoney(clanStat.blueCrystal));
        }
    }

    public setBonus(clanExpRatio: number, clanDefenceChance: number, distance: number): void {
        if (this.active && this.scene.scene.isActive()) {
            this.clanBonusPanel.updateValues(clanExpRatio, clanDefenceChance, distance);
        }
    }

    public setGears(gears: number): void {
        if (this.active && this.scene.scene.isActive()) {
            this.clanBonusPanel.updateGears(gears);
        }
    }
}
